const Locations = () => {
    return (
        <div className="Locations">
            hey
        </div>
    );
}

export default Locations;